import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import UpdateArticle from './UpdateArticle';

function ArticlesDash({ showMessage, page_title }) {

  useEffect(() => {
                document.title = page_title;
            }, [page_title]);

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("view");
  const [showUpdate, setShowUpdate] = useState(false);
  const [currentArticleId, setCurrentArticleId] = useState(null);

  const [issues, setIssues] = useState([]);
  const [issueId, setIssueId] = useState("");
  const [type, setType] = useState("");
  const [title, setTitle] = useState("");
  const [authors, setAuthors] = useState("");
  const [keywords, setKeywords] = useState("");
  const [abstract, setAbstract] = useState("");
  const [file, setFile] = useState(null);
  const fileRef = useRef(null);

  const [articles, setArticles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const tabActivated = (tabName) => {
    navigate(`?tab=${tabName}`);
    setActiveTab(tabName);
    setShowUpdate(false);
  };

  const reloadForm = () => {
    setIssueId("");
    setType("");
    setTitle("");
    setAuthors("");
    setKeywords("");
    setAbstract("");
    setFile(null);
    if (fileRef.current) fileRef.current.value = "";
  };

  useEffect(() => {
  async function fetchIssues() {
    try {
      const res = await fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=getAllIssues');
      const data = await res.json();

      if(data.success){
        setIssues(data.issues);
      }
      
    } catch (error) {
      console.error('Failed to fetch issues:', error);
    }
  }

  fetchIssues();
}, []);


  const submitArticle = async () => {
    if (!issueId || !type || !title || !authors || !file || !keywords || !abstract) {
      showMessage("error", "All fields are required.");
      return;
    }

    const formData = new FormData();
    formData.append("issue_id", issueId);
    formData.append("type", type);
    formData.append("title", title);
    formData.append("authors", authors);
    formData.append("keywords", keywords);
    formData.append("abstract", abstract);
    formData.append("file", file);

    try {
      const response = await fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=submitArticle", {
        method: "POST",
        credentials: "include",
        body: formData
      });
      const data = await response.json();
      if (data.success) {
        showMessage("success", "Article submitted successfully.");
        reloadForm();
        tabActivated("view");
        setTimeout(() => window.location.reload(), 1000);
      } else {
        showMessage("error", data.error || "Submission failed.");
      }
    } catch (err) {
      console.error("Submit error:", err);
      showMessage("error", "An error occurred. Check console.");
    }
  };

  const deleteArticle = async (id) => {
    if (!window.confirm("Are you sure you want to delete this article?")) return;

    try {
      const res = await fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=deleteArticle", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id })
      });
      const data = await res.json();
      if (data.success) {
        showMessage("success", "Article deleted.");
        setTimeout(() => window.location.reload(), 1000);
      } else {
        showMessage("error", data.error);
      }
    } catch (err) {
      showMessage("error", err.message);
    }
  };

  const publishArticle = async (id) => {
    const formData = new FormData();
    formData.append("id", id);

    try {
      const response = await fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=togglePublishArticle", {
        method: "POST",
        credentials: "include",
        body: formData
      });
      const data = await response.json();
      if (data.success) {
        showMessage("success", `Article ${data.newStatus === "1" ? "published" : "unpublished"} successfully.`);
        setTimeout(() => window.location.reload(), 1000);
      } else {
        showMessage("error", data.error || "Publish toggle failed.");
      }
    } catch (err) {
      showMessage("error", "An error occurred.");
    }
  };

  const updateArticle = (id) => {
    setCurrentArticleId(id);
    setShowUpdate(true);
  };

  useEffect(() => {
    fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=getAllArticles")
      .then(res => res.json())
      .then(data => {
        if (data.success) setArticles(data.articles);
      })
      .catch(err => console.log(err));
  }, []);

  const dashLogout = () => {
    fetch("https://annalsofnursing.org/aon_backend/api/api.php?action=removeUserSession", {
      method: "GET",
      credentials: "include",
    })
      .then(res => res.json())
      .then(data => {
        if (data.success === 'true') {
          showMessage("success", "Logged out successfully.");
          navigate("/dashboard/login");
        }
      })
      .catch(() => showMessage("error", "Something went wrong."));
  };

  const dashBack = () => navigate("/dashboard");

  const getIssueTitle = (id) => {
    const issue = issues.find(issue => issue.id === id);
    return issue ? issue.title : `Issue ${id}`;
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = articles.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(articles.length / itemsPerPage);

  const articleTypes = [
    { label: "Original Article", value: "original article" },
    { label: "Review", value: "review" },
    { label: "Case Report", value: "case report" },
    { label: "Letter to the Editor", value: "letter to the editor" },
    { label: "Commentary", value: "commentary" },
    { label: "Book Review", value: "book review" },
    { label: "Professional Paper", value: "professional paper" },
    { label: "Editorial", value: "editorial" },
    { label: "Conference Paper", value: "conference paper" }
  ];

  return (
    <div className="dash_section">
      <div className="dash_wrapper">

        <div className='dash_logout'>
          <div className='dash_back_cta' onClick={dashBack}>Dashboard</div>
          <div className='dash_logout_cta' onClick={dashLogout}>Logout</div>
        </div>


        <div className="dash_header_tabs">
          <div className='dash_header_tab' onClick={() => tabActivated('view')} style={activeTab === "view" ? { borderBottom: '2px solid gray' } : {}}>View Articles</div>
          <div className='dash_header_tab' onClick={() => tabActivated('create')} style={activeTab === "create" ? { borderBottom: '2px solid gray' } : {}}>Add New Article</div>
        </div>

        {/* View */}
        <div className="dash_body_tab" style={{ display: activeTab === "view" ? "block" : "none" }}>
          {!showUpdate ? (
            <>
              <h2 className='dash_body_title'>Articles</h2>
              {currentItems.map(article => (
                <div key={article.id} className="dash_table_body_wrapper">
                  <p className='articles_dash_paragraph'><strong>ID:</strong> {article.id}</p>
                  <p className='articles_dash_paragraph'><strong>Issue ID:</strong> {getIssueTitle(article.issue_id)}</p>
                  <p className='articles_dash_paragraph'><strong>Type:</strong> {article.type}</p>
                  <p className='articles_dash_paragraph'><strong>Title:</strong> {article.title}</p>
                  <p className='articles_dash_paragraph'><strong>Authors:</strong> {article.authors}</p>
                  <p className='articles_dash_paragraph'><strong>Keywords:</strong> {article.keywords}</p>
                  <p className='articles_dash_paragraph'><strong>Abstract:</strong> {article.abstract}</p>
                  <p className='pdf_view_issue'><a href={article.file} download target="_blank" rel="noreferrer">View PDF</a></p>

                  <button className='publish_issue' onClick={() => publishArticle(article.id)}
                    style={{
                      backgroundColor: article.publish === 1 ? "orange" : "green",
                      color: "white", padding: "6px 12px", border: "none", borderRadius: "4px"
                    }}>
                    {article.publish === 1 ? "Unpublish" : "Publish"}
                  </button>

                  <div className="dash_table_info_actions article_actions">
                    <button className='dash_table_info_action' onClick={() => updateArticle(article.id)}>Update</button>
                    <button className="dash_table_info_action info_action_delete" onClick={() => deleteArticle(article.id)}>Delete</button>
                  </div>
                </div>
              ))}

              {/* Pagination */}
              <div style={{ marginTop: "1rem", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem" }}>
                {/* Left Arrow */}
                    <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{
                        height: "40px",
                        width: "40px",
                        backgroundColor: "#eee",
                        color: "#000",
                        border: "none",
                        borderRadius: "100px",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        opacity: currentPage === 1 ? 0.5 : 1
                        }}
                    >
                        <span className="fa-solid fa-arrow-left"></span>
                    </button>

                    {/* Page Info */}
                    <span>
                        Page {currentPage} of {totalPages}
                    </span>

                    {/* Right Arrow */}
                    <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{
                        height: "40px",
                        width: "40px",
                        backgroundColor: "#eee",
                        color: "#000",
                        border: "none",
                        borderRadius: "100px",
                        cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                        opacity: currentPage === totalPages ? 0.5 : 1
                        }}
                    >
                        <span className="fa-solid fa-arrow-right"></span>
                    </button>
              </div>
            </>
          ) : (
            <>
              <h2 className='dash_body_title'>Update Article</h2>
              <UpdateArticle id={currentArticleId} showMessage={showMessage} setShowUpdate={setShowUpdate} />
            </>
          )}
        </div>

        {/* Create */}
        <div className="dash_body_tab" style={{ display: activeTab === "create" ? "block" : "none" }}>
          <h2 className='dash_body_title'>Add New Article</h2>
          <div className='dash_update_records'>
            <label>1. Issue ID</label><br />
            <select
              className='dash_input select_dash'
              value={issueId}
              onChange={(e) => setIssueId(e.target.value)}
            >
              <option value="">Select Issue</option>
              {issues.map((issue) => (
                <option key={issue.id} value={issue.id}>
                  {issue.title}
                </option>
              ))}
            </select><br />
            <label>2. Type</label><br />
            <select
              className='dash_input select_dash'
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="">Select Article Type</option>
              {articleTypes
                .filter(option => option.value !== 'all') // Exclude "All Article Types" in create form
                .map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
              ))}
            </select><br />
            <label>3. Title</label><br />
            <input className='dash_input' type="text" value={title} onChange={(e) => setTitle(e.target.value)} /><br />
            <label>4. Authors (comma-separated)</label><br />
            <input className='dash_input' type="text" value={authors} onChange={(e) => setAuthors(e.target.value)} /><br />
            <label>5. Keywords (comma-separated)</label><br />
            <input className='dash_input' type="text" value={keywords} onChange={(e) => setKeywords(e.target.value)} /><br />
            <label>6. Abstract</label><br />
            <textarea className='dash_input' value={abstract} onChange={(e) => setAbstract(e.target.value)} /><br />
            <label>7. Upload PDF</label><br />
            <input ref={fileRef} className='dash_file_upload' type="file" accept="application/pdf" onChange={(e) => setFile(e.target.files[0])} /><br />

            <div className='dash_buttons_wrapper'>
              <button className='dash_form_buttom' onClick={submitArticle}>Submit</button>
              <button className='dash_form_buttom dash_reset' onClick={reloadForm}>Reset</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default ArticlesDash;
